import { AppBar } from "@mui/material";
import GlobalHeader from "@/components/app/Navigation/GlobalHeader";
import MainNavigation from "./MainNavigation";

function Navigation() {
  return (
    <AppBar
      position="static"
      color="transparent"
      sx={{ bgcolor: "var(--modus-wc-color-white)" }}
    >
      <GlobalHeader />
      <MainNavigation />
    </AppBar>
  );
}
export default Navigation;
